// debounce an async function
function debounce(func, wait = 0, options = {}) {
  const { leading = false, maxWait, trailing = true } = options;
  let timeout;
  let lastArgs;
  let lastPromise; // Resolve for waiting call
  let maxTime;

  function resetTimeout() {
    if (timeout) {
      if (lastPromise) {
        lastPromise.resolve(undefined);
        lastPromise = undefined;
      }
      clearTimeout(timeout);
    }
  }

  function startTimeout() {
    const delay = maxTime ? Math.min(maxTime - Date.now(), wait) : wait;
    timeout = setTimeout(() => {
      invokeFunc(false);
    }, delay);
  }

  function invokeFunc(force) {
    if ((!force && !trailing) || !lastPromise) {
      resetTimeout();
      return null;
    }
    const { resolve, reject } = lastPromise;
    if (maxWait) {
      maxTime = Date.now() + maxWait;
    }
    startTimeout();
    lastPromise = undefined;
    func(...lastArgs)
      .then(resolve)
      .catch(reject);
    return { resolve, reject };
  }

  return function debounced(...args) {
    lastArgs = args;
    const force = leading && !timeout;
    resetTimeout();
    return new Promise((resolve, reject) => {
      lastPromise = { resolve, reject };
      if (force) {
        invokeFunc(true);
      } else {
        startTimeout();
      }
    });
  };
}

export default debounce;
